import {
  Injectable
} from '@angular/core';
import { getApp } from '@angular/fire/app';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
//import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Observable,
  Observer
} from 'rxjs';
//import { tap, map } from 'rxjs/operators';
import {
  IBrewfather
} from '../../models/brewfather';
import { regionConst } from '../dal/databaseConstants';


@Injectable({
  providedIn: 'root'
})
export class BrewfatherExternalService {

  constructor() { }


  getBatches(brewfather: IBrewfather, offset: number, status: string): Promise<any> {
    const functions = getFunctions(getApp(), regionConst.europeWest1);
    const callable = httpsCallable(functions, 'getBrewfatherBatchesV2');
    const data$ = callable({
      userId: brewfather.userId,
      apiKey: brewfather.apiKey,
      offset: offset,
      status: status
    });

    return data$;
  }

  getBatchesPaged(brewfather: IBrewfather, offset: string, limit: number, status: string): Promise<any> {
    const functions = getFunctions(getApp(), regionConst.europeWest1);
    const callable = httpsCallable(functions, 'getBrewfatherBatchesPagesV2');
    const data$ = callable({
      userId: brewfather.userId,
      apiKey: brewfather.apiKey,
      offset: offset,
      limit: limit,
      status: status
    });

    return data$;
  }

  getBatch(brewfather: IBrewfather | undefined, id: string): Promise<any> {
    const functions = getFunctions(getApp(), regionConst.europeWest1);
    const callable = httpsCallable(functions, 'getBrewfatherBatchV2');
    const data$ = callable({
      userId: brewfather?.userId,
      apiKey: brewfather?.apiKey,
      id: id
    });

    return data$;
  }

  /** All device readings (SG + temp over time) for a batch — fermentation graph. */
  getReadings(brewfather: IBrewfather | undefined, id: string): Promise<any> {
    const functions = getFunctions(getApp(), regionConst.europeWest1);
    const callable = httpsCallable(functions, 'getBrewfatherBatchReadingsV2');
    const data$ = callable({
      userId: brewfather?.userId,
      apiKey: brewfather?.apiKey,
      id: id
    });

    return data$;
  }

  /** Latest device reading (SG + temp in °C) for a batch. */
  getLastReading(brewfather: IBrewfather | undefined, id: string): Promise<any> {
    const functions = getFunctions(getApp(), regionConst.europeWest1);
    const callable = httpsCallable(functions, 'getBrewfatherBatchLastReadingV2');
    const data$ = callable({
      userId: brewfather?.userId,
      apiKey: brewfather?.apiKey,
      id: id
    });

    return data$;
  }


}
